module.exports = __webpack_public_path__ + "static/media/404-error-page-found.875dbc14.jpg";